<template>
  <DataList
    title="Сервіси"
    resource="services"
    :columns="columns"
    :filter="filter"
    :get-items-fn="getServices"
    search-label="Пошук за скороченою назвою, артикулем"
    :is-header-filter="true"
  >
    <template v-slot:header-filters>
      <v-row>
        <v-col
          md="12"
          sm="12"
        >
          <ServiceTypeSelect
            v-model="serviceType"
            label="Тип сервісу"
            class="ma-1"
          />
        </v-col>
      </v-row>
    </template>
    <template v-slot:action-buttons>
      <DownloadFile
        :location="`services/rpc/export-to-excel`"
        filename="Сервіси"
        extension="xlsx"
        tooltip="Завантажити у форматі Excel"
      />
    </template>
  </DataList>
</template>

<script>
import DownloadFile from "../../../components/DowloadFile.vue";
import * as servicesApi from "../../../backend/servicesApi.js";
import ServiceTypeSelect from "../service-types/ServiceTypeSelect.vue";

export default {
  components: {
    DownloadFile,
    ServiceTypeSelect,
  },
  data: () => ({
    columns: [
      { title: "id", name: "id" },
      {
        title: "Тип",
        name: "type",
        dataPath: "serviceType.title",
        rowType: "wide",
      },
      { title: "Назва скорочено", name: "shortTitle", rowType: "wide" },
      {
        title: "Періодичність",
        name: "recurrence",
        component: "ServiceRecurrenceLabel",
      },
      {
        title: "грн, без ПДВ",
        name: "amount",
        type: "decimal",
      },
      {
        title: "грн, з ПДВ",
        name: "amountWithVAT",
        type: "decimal",
      },
      { title: "Артикул", name: "article" },
      {
        title: "Товар",
        name: "accountAsCommodity",
        type: "bool",
      },
      { title: "Примітки", name: "comments", cropLimit: 50 },
    ],
    serviceType: null,
  }),
  computed: {
    filter(){
      return {
        serviceType: {
          id: this.serviceType ? this.serviceType.id : "",
          title: this.serviceType ? this.serviceType.title : "",
        },
      };
    },
  },
  methods: {
    getServices(...args) {
      const page = args[0];
      const rowsPerPage = args[1];
      const search = args[2];
      const filter = args[3];
      return servicesApi.getServices(page, rowsPerPage, search, filter);
    },
  },
};
</script>
